// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"cc708e38","765":"f67eb9fa"}[chunkId] + ".chunk.js";
};